export default __webpack_public_path__ + "static/media/12-month-chart.9313fd40.png";